import {z} from 'zod';

/**
 * Schema for get message by ID request params
 */
export const getMessageByIdRequestSchema = z.object({
  id: z.string().uuid().describe('Message ID'),
});

export type GetMessageByIdRequest = z.infer<typeof getMessageByIdRequestSchema>;
